import { startsWith } from 'lodash';

export const isImageContentType = (contentType) =>
  startsWith(contentType, 'image/');
